<template>
<div class="footer">
    <div class="footer__container-container">
      <span
        >❮ Udemy-vue-personalizado❯ by -
        <a href="https://github.com/JackelinGM" target="_blank"
          >Melissa Gutierrez Montalban 2021</a
        >
        <span>❤</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer {
  background-color: var(--color-black);
  text-align: center;
  padding: 5rem 0;
  color: var(--color-purple);
  margin-top: 100px;
}
span {
  color: aqua;
}

a {
  color: aqua;
}
</style>
